import { gql } from '@apollo/client';

export const CREATE_OR_UPDATE_BRAND = gql`
  mutation CREATE_OR_UPDATE_BRAND($brandData: CreateBrandDto!) {
    createOrUpdateBrand(brandData: $brandData) {
      id
      brandName
      businessEmail
      logoUrl
      description
      tags
    }
  }
`;

export const GET_BRAND = gql`
  query GET_BRAND {
    getBrand {
      id
      brandName
      businessEmail
      logoUrl
      description
      tags
    }
  }
`;